import Aside from './Aside.vue';
import Breadcrumb from './Breadcrumb.vue';
import Callout from './Callout.vue';
import Footer from './Footer.vue';
import Header from './Header.vue';
import Sidebar from './Sidebar.vue';
import SidebarNavIcons from './SidebarNavIcons.vue';
import Switch from './Switch.vue';
import Navigator from './Navigator.vue';
import SearchSession from './SearchSession.vue';
import ClientCardsManagement from './ClientCardsManagement.vue';

export {
  Aside,
  Breadcrumb,
  Callout,
  Footer,
  Header,
  Sidebar,
  Switch,
  SidebarNavIcons,
  Navigator,
  SearchSession,
  ClientCardsManagement
};



// WEBPACK FOOTER //
// ./src/components/commons/index.js